'use client';

import React, { useEffect, useState } from 'react';

import { appendChannelToUrl } from '@/utils/channel-data';

/** <a>, чей href дополняется channelCode (см. appendChannelToUrl). Использовать
 * вместо <a href={url}> для бэковых ссылок на поиск на сео-страницах.
 * Отдельный тип пропсов не заводим — он идентичен React.AnchorHTMLAttributes.
 *
 * Подмена href — в эффекте, после монтирования. Если вызвать appendChannelToUrl
 * прямо в рендере, код канала верно считается, но в реальный DOM после гидратации не попадает.
 */
const ChannelDecoratedLink: React.FC<React.AnchorHTMLAttributes<HTMLAnchorElement>> = ({ href, children, ...rest }) => {
  const [resolvedHref, setResolvedHref] = useState(href);

  useEffect(() => {
    setResolvedHref(href ? appendChannelToUrl(href) : href);
  }, [href]);

  return (
    <a href={resolvedHref} {...rest}>
      {children}
    </a>
  );
};

export default ChannelDecoratedLink;
